
<mapfre-generic-information-template
  [headerImageURL]="'./assets/img/images/headers/renewal.png'"
  [backButtonUrl]="'/information'"
  [type]="'page'">

    <h1 class="information-title">{{ 'YOUR_PERSONAL_AUTO_POLICY_RENEWAL' | translate }}</h1>
      <div class="row information-content">
        <div class="col">
            <p class="information-par-margin">
              {{ 'INFORMATION_RENEWAL_ONE' | translate }}
            </p>
          
          <h2 class="information-title">
             <svg width="24px" height="24px" viewBox="0 0 18 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <path d="M7.5,13.8 L16.5,13.8 L16.5,14.4 L7.5,14.4 L7.5,13.8 Z M8.1,15.9 L15.9,15.9 L15.9,16.5 L8.1,16.5 L8.1,15.9 Z M8.7,18 L15.3,18 L15.3,18.6 L8.7,18.6 L8.7,18 Z M12.15,12.3 C10.0789322,12.3 8.4,10.6210678 8.4,8.55 C8.4,6.47893219 10.0789322,4.8 12.15,4.8 C14.2210678,4.8 15.9,6.47893219 15.9,8.55 C15.9,10.6210678 14.2210678,12.3 12.15,12.3 Z M12.1499085,8.70015552 L11.3736984,6.9 L10.2,6.9 L10.2,10.5 L11.3736984,10.5 L11.3736984,8.70015552 L12.1499085,10.5 L12.9261185,8.70015552 L12.9261185,10.5 L14.1,10.5 L14.1,6.9 L12.9261185,6.9 L12.1499085,8.70015552 Z M20.5909091,24 L3.40909091,24 C3.18297205,24 3,23.7549818 3,23.4545455 L3,0.545454545 C3,0.243962727 3.18296591,0 3.40909091,0 L20.5909091,0 C20.817028,0 21,0.243954545 21,0.545454545 L21,23.4545455 C21,23.7549709 20.8170341,24 20.5909091,24 Z M20.1818182,22.9090909 L20.1818182,1.09090909 L3.81818182,1.09090909 L3.81818182,22.9090909 L20.1818182,22.9090909 Z" id="doc-icon"></path>
              </defs>
              <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="04_Icons/small/policy-small" transform="translate(-3.000000, 0.000000)">
                      <mask id="doc-iconmask-2" fill="white">
                          <use xlink:href="#doc-icon"></use>
                      </mask>
                      <use id="Mask" fill="#737373" fill-rule="nonzero" xlink:href="#doc-icon"></use>
                  </g>
              </g>
            </svg>&nbsp;  {{ 'INFORMATION_RENEWAL_TWO' | translate}}
            </h2>
            <p class="information-par-margin">
              {{ 'INFORMATION_RENEWAL_THREE' | translate}}
          </p>
          <p class="information-par-margin">
              <strong>{{ 'INFORMATION_RENEWAL_FOUR' | translate}}</strong><br>
              {{ 'INFORMATION_RENEWAL_FIVE' | translate}}
            </p>
            <p class="information-par-margin">
              <strong>{{ 'INFORMATION_RENEWAL_SIX' | translate}}</strong><br>
              {{ 'INFORMATION_RENEWAL_SEVEN' | translate}}
            </p>
            <p class="information-par-margin">
              <strong> {{ 'INFORMATION_RENEWAL_EIGHT' | translate}}</strong><br>
              {{ 'INFORMATION_RENEWAL_NINE' | translate}}
            </p>
            <p class="information-par-margin">
              <strong>{{ 'INFORMATION_RENEWAL_TEN' | translate}}</strong><br>
              {{ 'INFORMATION_RENEWAL_ELEVEN' | translate}}
          </p>
          <h2 class="information-title">
            <div class="float-left"><svg-billing-svg></svg-billing-svg></div>&nbsp;  {{ 'INFORMATION_RENEWAL_TWELVE' | translate}}</h2>
          <p class="information-par-margin">
              {{ 'INFORMATION_RENEWAL_THIRTEEN' | translate}}
          </p>
          <p class="information-par-margin">
              {{ 'INFORMATION_RENEWAL_FOURTEEN' | translate}}
            </p>
            <p class="information-par-margin">
              <strong> {{ 'INFORMATION_RENEWAL_15' | translate}}</strong><br>
              {{ 'INFORMATION_RENEWAL_16' | translate}}
            </p>
            <h2 class="information-title">
                <svg width="24px" height="19px" viewBox="0 0 24 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                        <polygon id="path-1" points="7.60655738 17.4918033 22.0655738 3 24 4.93442623 7.60655738 21.3278689 0 13.7213115 1.90163934 11.7868852"></polygon>
                    </defs>
                    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="04_Icons/small/yes" transform="translate(0.000000, -3.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlink:href="#path-1"></use>
                            </mask>
                            <use id="Mask" fill="#000000" xlink:href="#path-1"></use>
                        </g>
                    </g>
                </svg>
                &nbsp;{{ 'INFORMATION_RENEWAL_17' | translate}}
              </h2>
                <p class="information-par-margin">
                {{ 'INFORMATION_RENEWAL_18' | translate}}
              </p>
              <p class="information-par-margin">
                  <strong>{{ 'INFORMATION_RENEWAL_19' | translate}}</strong><br>
                  {{ 'INFORMATION_RENEWAL_20' | translate}}
              </p>
              <p class="information-par-margin">
                  {{ 'INFORMATION_RENEWAL_21' | translate}}
              </p>
              <p class="information-par-margin">
                  {{ 'INFORMATION_RENEWAL_22' | translate}}
            </p>

        </div>
      </div>
</mapfre-generic-information-template>